/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import App from "App";
import "./assets/fonts/fonts.css"; 

// Vision UI Context Provider
import { VisionUIControllerProvider } from "context";

import { initEmbedState } from "embed";

initEmbedState();

ReactDOM.render(
  <HashRouter>
    <VisionUIControllerProvider>
      <App />
    </VisionUIControllerProvider>
  </HashRouter>,
  document.getElementById("root")
);
